module.exports = __webpack_public_path__ + "img/banner-mask.cf255df9.svg";